<script setup lang="ts">
import AdSlot from '../components/AdSlot.vue';
import { AD_SIZE_PRESETS } from '../config/ads';
</script>

<template>
  <div class="content-page">
    <section class="content-hero">
      <p class="page-badge">Sobre</p>
      <h1>VemChuva Brasil</h1>
      <p class="hero-lead">
        Um radar de chuva em português, pensado para quem precisa tomar decisões rápidas sobre clima no Brasil
        — sem telas poluídas e com foco na clareza.
      </p>
      <div class="page-meta">
        <span>Atualizado em fevereiro de 2025</span>
        <span>Projeto independente, aberto para parcerias</span>
      </div>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.top"
    />

    <section class="content-section">
      <h2>O que você encontra aqui</h2>
      <div class="content-grid three">
        <article class="content-card">
          <h3>Mapa interativo</h3>
          <p>Visualize chuva, temperatura e intensidade em tempo real por cidade, com raio ajustável e navegação por hora/dia.</p>
        </article>
        <article class="content-card">
          <h3>Alertas e contexto</h3>
          <p>Alertas oficiais são destacados para facilitar decisões rápidas. Cada cidade tem um painel com dados horários e acumulados.</p>
        </article>
        <article class="content-card">
          <h3>Experiência rápida</h3>
          <p>Sem necessidade de login. Cache local para manter buscas recentes, tema escuro/claro e filtros do seu jeito.</p>
        </article>
      </div>
    </section>

    <section class="content-section">
      <h2>Como os dados são tratados</h2>
      <div class="content-grid two">
        <article class="content-card">
          <h3>Fontes</h3>
          <p>Usamos dados meteorológicos reais fornecidos além de camadas abertas (OpenStreetMap e IBGE para malhas municipais).</p>
          <p>Indicamos a origem e o horário de coleta para manter transparência e rastreabilidade.</p>
        </article>
        <article class="content-card">
          <h3>Limitações</h3>
          <p>Previsões meteorológicas têm incertezas. O aplicativo não substitui orientações da Defesa Civil, aeroportos, órgãos oficiais ou serviços médicos.</p>
        </article>
      </div>
    </section>

    <section class="content-section">
      <h2>Para quem fazemos</h2>
      <ul class="highlight-list">
        <li>Moradores que precisam decidir saídas, deslocamentos e eventos ao ar livre.</li>
        <li>Equipes de campo que monitoram chuva, vento e temperatura para rotas e logística.</li>
        <li>Criadores de conteúdo ou órgãos locais que divulgam avisos rápidos para suas comunidades.</li>
      </ul>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.middle"
    />

    <section class="content-section">
      <h2>Compromissos de qualidade</h2>
      <div class="content-grid two">
        <article class="content-card">
          <h3>Transparência</h3>
          <p>Sinalizamos a origem dos dados, horário de atualização e diferenças entre previsões e alertas.</p>
        </article>
        <article class="content-card">
          <h3>Privacidade</h3>
          <p>Não pedimos cadastro. Preferências (tema, raio de busca, últimas cidades) ficam guardadas apenas no seu dispositivo.</p>
        </article>
        <article class="content-card">
          <h3>Acessibilidade</h3>
          <p>Suporte a teclado, contraste reforçado e textos claros para leitura em dispositivos móveis.</p>
        </article>
        <article class="content-card">
          <h3>Publicidade responsável</h3>
          <p>Integramos o Google AdSense seguindo políticas de conteúdo seguro, com opção de desativar personalização de anúncios.</p>
        </article>
      </div>
    </section>

    <section class="content-section">
      <h2>Fale com a gente</h2>
      <p>Tem sugestões, deseja integrar dados ou reportar um problema? Escreva para <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a>.</p>
    </section>
  </div>
</template>
